<palantir-content class="palantir-accordion" [ngClass]="{ 'palantir-accordion--open': isOpen() }">
  <div class="palantir-accordion__header" (click)="toggleOpen()" (keydown.enter)="toggleOpen()">
    <!-- @deprecated: Use the new header content projection instead -->
    @if (title) {
      <palantir-text title="subtitle">{{ title }}</palantir-text>
    }
    <ng-content select="[palantir-accordion-header], palantir-accordion-header" />
    <palantir-icon name="expand-more-outline" />
  </div>

  <div class="palantir-accordion__body" [@expandCollapse]="isOpen() ? 'expanded' : 'collapsed'">
    @if (!disabled) {
      <div class="palantir-accordion__content">
        <ng-content />
      </div>
    } @else {
      <div class="palantir-accordion__disabled-banner">
        <palantir-icon [name]="disabledIcon" class="palantir-accordion__disabled-icon" />
        <palantir-text size="base" type="description">{{ disabledText }}</palantir-text>
      </div>
    }
  </div>
</palantir-content>
